import {
    useState,
    useMemo,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import {
    RequestConfig,
} from 'app/types/request.types'

import getSkyMindSyncFields from './SkyMindSync.fields'

const SkyMindSync = ({
    skyMindId,
    invalidate,
    requestParams,
}: {
    skyMindId: number,
    invalidate: () => void,
    requestParams: RequestConfig,
}) => {
    const [
        value,
        setValue,
    ] = useState<{
        availableInSkyMind: boolean,
        skyMindId: number,
    }>({
        availableInSkyMind: undefined,
        skyMindId: undefined,
    })

    const formData = useMemo(() => {
        if (skyMindId) {
            return {
                availableInSkyMind: true,
                skyMindId,
            }
        }
        return {
            availableInSkyMind: value?.availableInSkyMind,
            skyMindId: value?.availableInSkyMind ? value?.skyMindId : null,
        }
    }, [
        skyMindId,
        value,
    ])

    const skyMindSyncFields = useMemo(() => {
        return getSkyMindSyncFields(
            Boolean(skyMindId),
            value.availableInSkyMind,
        )
    }, [
        skyMindId,
        value.availableInSkyMind,
    ])

    return (
        <FormWithControls
            name="SkyMindSync"
            value={formData}
            fields={skyMindSyncFields}
            setExternalValue={setValue}
            requestParams={requestParams}
            onSuccess={invalidate}
            onCancel={invalidate}
            exists
        />
    )
}

export default SkyMindSync
